export function initialize() {
    $('.js-graph-area').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        var animationDuration = 2500;

        var area = $(this);

        var items = [];
        var maxValue = 0;
        var maxWidth = 0;

        area.find('.js-graph-counter').each(function () {
            var v = parseInt($(this).data('value'));
            items[items.length] = {
                entity: $(this),
                actual: 0,
                final: v
            };

            maxValue = Math.max(maxValue, v);
        });

        area.find('.js-graph-progress').each(function () {
            maxWidth = Math.max(maxWidth, parseInt($(this).width()));
        });

        area.find('.js-graph-progress-bar').css('width', maxWidth + 'px');

        var step = Math.floor(maxValue / (animationDuration / 15));

        var counter = setInterval(function () {
            $.each(items, function (k, v) {
                v.actual = Math.min(v.actual + step, v.final);
                v.entity.text(graphFormatNumber(v.actual));
            });
        }, 15);

        setTimeout(function () {
            clearInterval(counter);

            $.each(items, function (k, v) {
                v.entity.text(graphFormatNumber(v.final));
            });
        }, animationDuration + 100)
    });

    function graphFormatNumber(number)
    {
        number = number+'';
        var pad = '000000000000000';
        var leftPadSize = (Math.ceil(number.length/3)*3)-number.length;
        var paddedString = pad.substring(0, leftPadSize) + number;
        var chunkSize = 3;
        var chunks = [];
        var isFirst = true;
        var chunk;
        while (paddedString) {

            if (paddedString.length < chunkSize) {
                chunk = paddedString;
                break;
            }
            else {
                chunk = paddedString.substr(0, chunkSize);
                paddedString = paddedString.substr(chunkSize);
            }

            chunks.push(isFirst ? parseInt(chunk) : chunk);
            isFirst = false;
        }

        return chunks.join(' ');
    }
}

export default {};
